import { Modal, Stack, Text } from '@mantine/core';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import type {
	BulkClaimOnBehalfPreviewRes,
	BulkClaimOnBehalfRes,
} from '@dealstack/shared/lib/generated';
import type { BulkClaimGenerationJobStatusRes } from '@dealstack/shared/lib/backendClient';
import { BulkClaimOnBehalfPreview } from './BulkClaimOnBehalfPreview';
import { BulkClaimOnBehalfResult } from './BulkClaimOnBehalfResult';

interface Props {
	preview: BulkClaimOnBehalfPreviewRes | null;
	isLoadingPreview: boolean;
	isSubmitting: boolean;
	result: BulkClaimOnBehalfRes | null;
	generationJobStatus: BulkClaimGenerationJobStatusRes | null;
	onConfirm: (signerIds: string[]) => void;
	onClose: () => void;
}

export const BulkClaimOnBehalfModal = ({
	preview,
	isLoadingPreview,
	isSubmitting,
	result,
	generationJobStatus,
	onConfirm,
	onClose,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	const modalTitle = result ? (
		<Text fw={700} size="lg">
			{tMipManage('documents_page.claim_on_behalf.results_title')}
		</Text>
	) : (
		<Stack gap={2}>
			<Text fw={700} size="lg">
				{tMipManage('documents_page.claim_on_behalf.title')}
			</Text>
			<Text size="sm" c="dimmed">
				{tMipManage('documents_page.claim_on_behalf.subtitle')}
			</Text>
		</Stack>
	);

	return (
		<Modal opened={true} onClose={onClose} title={modalTitle} centered size="lg">
			{result ? (
				<BulkClaimOnBehalfResult
					result={result}
					generationJobStatus={generationJobStatus}
					onClose={onClose}
				/>
			) : (
				<BulkClaimOnBehalfPreview
					preview={preview}
					isLoadingPreview={isLoadingPreview}
					isSubmitting={isSubmitting}
					onConfirm={onConfirm}
					onClose={onClose}
				/>
			)}
		</Modal>
	);
};
